import { AuthService } from "./../shared/services/auth.service";
import { AfterViewInit, Component, OnInit } from "@angular/core";
import * as firebase from "firebase/app";
import { AngularFireAuth } from "angularfire2/auth";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { debounceTime } from "rxjs/operator/debounceTime";
import { Subject } from "rxjs/Subject";
import { Subscription } from "rxjs/Subscription";
import { Constants } from "../helper/constants";
import { AccountService } from "../shared/account/account.service";
import { BackendService } from "../shared/services/backend.service";
import { ProfileService } from "../shared/user/profile.service";
import { FileUploadService } from "../shared/services/fileuploadservice";
import { Router } from "@angular/router";
import { LoaderService } from "../shared/services/loader.service";
import { THIS_EXPR } from "../../../node_modules/@angular/compiler/src/output/output_ast";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.css"]
})
export class UserProfileComponent implements AfterViewInit, OnInit {
  private authInstance: AngularFireAuth;
  authState: firebase.User | null;
  isCollapsed = true;
  modalReference: NgbModalRef;
  private _alert = new Subject<string>();
  pageSuccessMessage: string;
  pageErrorMessage: string;
  modalSuccessMessage: string;
  modalErrorMessage: string;
  subscription: Subscription;
  oldPhoneNumber;
  phoneNumber;
  oldPassword;
  newPassword;
  newPasswordDuplicate;
  activeRouteIndex = 0;
  userId: string;
  profile;

  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private modalService: NgbModal,
    private profileService: ProfileService,
    private uploadService: FileUploadService,
    private router: Router,
    private loaderService: LoaderService
  ) {
    this.authInstance = this.authService.getAngularFireAuthInstance();
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(this.authState.email);
  }

  ngOnInit(): void {
    this.accountService.getProfile(this.userId).subscribe((profile: any) => {
      this.profile = profile;
      this.phoneNumber = profile.phoneNumber;
      this.oldPhoneNumber = profile.phoneNumber;
      this.stopLoader();
    });
  }

  ngAfterViewInit(): void {
    this.loaderService.startLoader();
  }

  stopLoader(): void {
    this.loaderService.stopLoader();
  }

  verifySelectedFileTypeAndSize(file): void {
    if (file.length > 0) {
      const fileType = file[0].type;
      const fileSize = file[0].size;
      if (fileType !== "image/png" && fileType !== "image/jpeg") {
        this.showAlertonPage(
          false,
          "Image type is not supported. Supported image types are \".jpg\" and \".png\"."
        );

        return;
      }
      if (fileSize > Constants.maxFileSize) {
        this.showAlertonPage(
          false,
          "Image size is too large. Maximum size is 5MB."
        );

        return;
      }
      this.uploadProfilePicture(file[0]);
    }
  }

  uploadProfilePicture(file): void {
    this.loaderService.startLoader();
    this.uploadService.upload("avatars", file).subscribe(avatar => {
      this.profileService.updateAvatar(this.userId, avatar);
      this.showAlertonPage(true, "Picture uploaded successfully.");
    });
  }

  updatePhoneNumber(): void {
    if (this.phoneNumber !== this.oldPhoneNumber) {
      this.profileService.updatePhoneNumber(this.userId, this.phoneNumber);
      this.showAlertonPage(true, "Phone number updated successfully.");
    }
    this.isCollapsed = true;
  }

  showPasswordForm(modal): void {
    this.oldPassword = "";
    this.newPassword = "";
    this.newPasswordDuplicate = "";
    this.openModal(modal, "md");
  }

  updatePassword(): void {
    const userId = BackendService.generateUserId(this.profile.email);
    const currentPassword = localStorage.getItem(`${userId}-loopmi-secret`);
    if (this.oldPassword !== currentPassword) {
      this.showAlertInModal(false, "You entered an incorrect old password.");

      return;
    } else if (this.newPassword !== this.newPasswordDuplicate) {
      this.showAlertInModal(false, "Passwords do not match.");

      return;
    } else {
      this.loaderService.startLoader();
      this.authService
        .updatePassword(this.oldPassword, this.newPassword)
        .then(() => {
          this.close();
          this.loaderService.stopLoader();
          this.authInstance.auth
            .signOut()
            .then(() => this.router.navigate(["/account/login"]));
        })
        .catch(error => {
          console.log("error = " + error);
        });
    }
  }

  openModal(modal, modalSize): void {
    this.modalReference = this.modalService.open(modal, { size: modalSize });
  }

  close(): void {
    this.modalReference.close();
  }

  showAlertonPage(msgType, msg): void {
    this.subscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.pageSuccessMessage = message)
          : (this.pageErrorMessage = message)
    );
    debounceTime
      .call(this._alert, 4000)
      .subscribe(
        () =>
          msgType
            ? (this.pageSuccessMessage = undefined)
            : (this.pageErrorMessage = undefined)
      );
    this._alert.next(msg);
    this.subscription.unsubscribe();
  }

  showAlertInModal(msgType, msg): void {
    this.subscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.modalSuccessMessage = message)
          : (this.modalErrorMessage = message)
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(
        () =>
          msgType
            ? (this.modalSuccessMessage = undefined)
            : (this.modalErrorMessage = undefined)
      );
    this._alert.next(msg);
    this.subscription.unsubscribe();
  }

  isNumber(event: any): boolean {
    const charCode = event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/user-profile/user-profile.component.ts